import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useId } from 'react';
import { TERA_TYPE_OPTIONS, type TeraTypeOption } from '../../constants/tera-types';

interface TeraTypeSelectProps {
  value?: number;
  onChange: (value: number) => void;
  variant?: 'sidebar' | 'card';
  label?: string;
  stopPropagation?: boolean;
  options?: TeraTypeOption[];
  includeNoneOption?: boolean;
}

function TeraTypeSelect({
  value,
  onChange,
  variant = 'sidebar',
  label = 'テラスタイプを選択',
  stopPropagation,
  options,
  includeNoneOption = true,
}: TeraTypeSelectProps) {
  const labelId = useId();
  const baseOptions = options ?? TERA_TYPE_OPTIONS;
  const resolvedOptions = includeNoneOption ? baseOptions : baseOptions.filter((option) => option.id !== 0);
  const displayValue = value ?? 0;

  const stopEvent = stopPropagation
    ? (event: React.SyntheticEvent) => {
        event.stopPropagation();
      }
    : undefined;

  return (
    <Box>
      <FormControl size="small" sx={variant === 'card' ? undefined : { width: 'calc(12ch + 5px)' }}>
        {variant === 'sidebar' && <InputLabel id={labelId}>{label}</InputLabel>}
        <Select
          labelId={variant === 'sidebar' ? labelId : undefined}
          label={variant === 'sidebar' ? label : undefined}
          value={displayValue}
          onChange={(event) => onChange(Number(event.target.value))}
          // カード内の折りたたみ等と干渉しないように伝播を止める
          onMouseDown={stopEvent}
          onClick={stopEvent}
          onKeyDown={stopEvent}
          sx={
            variant === 'card'
              ? {
                  fontSize: '0.7rem',
                  minWidth: 80,
                  '& .MuiSelect-select': {
                    padding: '2px 6px',
                    textAlign: 'center',
                  },
                }
              : undefined
          }
        >
          {resolvedOptions.map((typeOption) => (
            <MenuItem
              key={typeOption.id}
              value={typeOption.id}
              sx={variant === 'card' ? { fontSize: '0.7rem', justifyContent: 'center' } : undefined}
            >
              {typeOption.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default TeraTypeSelect;
